/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CostsRouteImport } from './routes/costs'
import { Route as EuRouteImport } from './routes/eu'
import { Route as EuTariffRouteImport } from './routes/eu-tariff'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as GspPlusRouteImport } from './routes/gsp-plus'
import { Route as HsRouteImport } from './routes/hs'
import { Route as IncotermsRouteImport } from './routes/incoterms'
import { Route as InvoiceRouteImport } from './routes/invoice'
import { Route as LeadsRouteImport } from './routes/leads'
import { Route as LogisticsRouteImport } from './routes/logistics'
import { Route as MarketsRouteImport } from './routes/markets'
import { Route as OpportunitiesRouteImport } from './routes/opportunities'
import { Route as PaymentsRouteImport } from './routes/payments'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ToolsRouteImport } from './routes/tools'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CostsRoute = CostsRouteImport.update({
  id: '/costs',
  path: '/costs',
  getParentRoute: () => rootRouteImport,
} as any)
const EuRoute = EuRouteImport.update({
  id: '/eu',
  path: '/eu',
  getParentRoute: () => rootRouteImport,
} as any)
const EuTariffRoute = EuTariffRouteImport.update({
  id: '/eu-tariff',
  path: '/eu-tariff',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const GspPlusRoute = GspPlusRouteImport.update({
  id: '/gsp-plus',
  path: '/gsp-plus',
  getParentRoute: () => rootRouteImport,
} as any)
const HsRoute = HsRouteImport.update({
  id: '/hs',
  path: '/hs',
  getParentRoute: () => rootRouteImport,
} as any)
const IncotermsRoute = IncotermsRouteImport.update({
  id: '/incoterms',
  path: '/incoterms',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoiceRoute = InvoiceRouteImport.update({
  id: '/invoice',
  path: '/invoice',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsRoute = LeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const LogisticsRoute = LogisticsRouteImport.update({
  id: '/logistics',
  path: '/logistics',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketsRoute = MarketsRouteImport.update({
  id: '/markets',
  path: '/markets',
  getParentRoute: () => rootRouteImport,
} as any)
const OpportunitiesRoute = OpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsRoute = ToolsRouteImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/costs': typeof CostsRoute
  '/eu': typeof EuRoute
  '/eu-tariff': typeof EuTariffRoute
  '/feedback': typeof FeedbackRoute
  '/gsp-plus': typeof GspPlusRoute
  '/hs': typeof HsRoute
  '/incoterms': typeof IncotermsRoute
  '/invoice': typeof InvoiceRoute
  '/leads': typeof LeadsRoute
  '/logistics': typeof LogisticsRoute
  '/markets': typeof MarketsRoute
  '/opportunities': typeof OpportunitiesRoute
  '/payments': typeof PaymentsRoute
  '/pricing': typeof PricingRoute
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/tools': typeof ToolsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/costs': typeof CostsRoute
  '/eu': typeof EuRoute
  '/eu-tariff': typeof EuTariffRoute
  '/feedback': typeof FeedbackRoute
  '/gsp-plus': typeof GspPlusRoute
  '/hs': typeof HsRoute
  '/incoterms': typeof IncotermsRoute
  '/invoice': typeof InvoiceRoute
  '/leads': typeof LeadsRoute
  '/logistics': typeof LogisticsRoute
  '/markets': typeof MarketsRoute
  '/opportunities': typeof OpportunitiesRoute
  '/payments': typeof PaymentsRoute
  '/pricing': typeof PricingRoute
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/tools': typeof ToolsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/costs': typeof CostsRoute
  '/eu': typeof EuRoute
  '/eu-tariff': typeof EuTariffRoute
  '/feedback': typeof FeedbackRoute
  '/gsp-plus': typeof GspPlusRoute
  '/hs': typeof HsRoute
  '/incoterms': typeof IncotermsRoute
  '/invoice': typeof InvoiceRoute
  '/leads': typeof LeadsRoute
  '/logistics': typeof LogisticsRoute
  '/markets': typeof MarketsRoute
  '/opportunities': typeof OpportunitiesRoute
  '/payments': typeof PaymentsRoute
  '/pricing': typeof PricingRoute
  '/services': typeof ServicesRoute
  '/settings': typeof SettingsRoute
  '/tools': typeof ToolsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/costs'
    | '/eu'
    | '/eu-tariff'
    | '/feedback'
    | '/gsp-plus'
    | '/hs'
    | '/incoterms'
    | '/invoice'
    | '/leads'
    | '/logistics'
    | '/markets'
    | '/opportunities'
    | '/payments'
    | '/pricing'
    | '/services'
    | '/settings'
    | '/tools'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/costs'
    | '/eu'
    | '/eu-tariff'
    | '/feedback'
    | '/gsp-plus'
    | '/hs'
    | '/incoterms'
    | '/invoice'
    | '/leads'
    | '/logistics'
    | '/markets'
    | '/opportunities'
    | '/payments'
    | '/pricing'
    | '/services'
    | '/settings'
    | '/tools'
  id:
    | '__root__'
    | '/'
    | '/costs'
    | '/eu'
    | '/eu-tariff'
    | '/feedback'
    | '/gsp-plus'
    | '/hs'
    | '/incoterms'
    | '/invoice'
    | '/leads'
    | '/logistics'
    | '/markets'
    | '/opportunities'
    | '/payments'
    | '/pricing'
    | '/services'
    | '/settings'
    | '/tools'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CostsRoute: typeof CostsRoute
  EuRoute: typeof EuRoute
  EuTariffRoute: typeof EuTariffRoute
  FeedbackRoute: typeof FeedbackRoute
  GspPlusRoute: typeof GspPlusRoute
  HsRoute: typeof HsRoute
  IncotermsRoute: typeof IncotermsRoute
  InvoiceRoute: typeof InvoiceRoute
  LeadsRoute: typeof LeadsRoute
  LogisticsRoute: typeof LogisticsRoute
  MarketsRoute: typeof MarketsRoute
  OpportunitiesRoute: typeof OpportunitiesRoute
  PaymentsRoute: typeof PaymentsRoute
  PricingRoute: typeof PricingRoute
  ServicesRoute: typeof ServicesRoute
  SettingsRoute: typeof SettingsRoute
  ToolsRoute: typeof ToolsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/costs': {
      id: '/costs'
      path: '/costs'
      fullPath: '/costs'
      preLoaderRoute: typeof CostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eu': {
      id: '/eu'
      path: '/eu'
      fullPath: '/eu'
      preLoaderRoute: typeof EuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eu-tariff': {
      id: '/eu-tariff'
      path: '/eu-tariff'
      fullPath: '/eu-tariff'
      preLoaderRoute: typeof EuTariffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gsp-plus': {
      id: '/gsp-plus'
      path: '/gsp-plus'
      fullPath: '/gsp-plus'
      preLoaderRoute: typeof GspPlusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hs': {
      id: '/hs'
      path: '/hs'
      fullPath: '/hs'
      preLoaderRoute: typeof HsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/incoterms': {
      id: '/incoterms'
      path: '/incoterms'
      fullPath: '/incoterms'
      preLoaderRoute: typeof IncotermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoice': {
      id: '/invoice'
      path: '/invoice'
      fullPath: '/invoice'
      preLoaderRoute: typeof InvoiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads': {
      id: '/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof LeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logistics': {
      id: '/logistics'
      path: '/logistics'
      fullPath: '/logistics'
      preLoaderRoute: typeof LogisticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/markets': {
      id: '/markets'
      path: '/markets'
      fullPath: '/markets'
      preLoaderRoute: typeof MarketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opportunities': {
      id: '/opportunities'
      path: '/opportunities'
      fullPath: '/opportunities'
      preLoaderRoute: typeof OpportunitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools': {
      id: '/tools'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CostsRoute: CostsRoute,
  EuRoute: EuRoute,
  EuTariffRoute: EuTariffRoute,
  FeedbackRoute: FeedbackRoute,
  GspPlusRoute: GspPlusRoute,
  HsRoute: HsRoute,
  IncotermsRoute: IncotermsRoute,
  InvoiceRoute: InvoiceRoute,
  LeadsRoute: LeadsRoute,
  LogisticsRoute: LogisticsRoute,
  MarketsRoute: MarketsRoute,
  OpportunitiesRoute: OpportunitiesRoute,
  PaymentsRoute: PaymentsRoute,
  PricingRoute: PricingRoute,
  ServicesRoute: ServicesRoute,
  SettingsRoute: SettingsRoute,
  ToolsRoute: ToolsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
